import { NavLink, Route, Routes } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Landing from './pages/Landing';
import TrainingPhilosophy from './pages/TrainingPhilosophy';
import RunWithUs from './pages/RunWithUs';
import RoutesPage from './pages/Routes';
import Donate from './pages/Donate';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import './App.css';

const navLinks = [

  { to: '/training-philosophy', label: 'Training' },
  { to: '/routes', label: 'Routes' },
  { to: '/run-with-us', label: 'Run With Us' },
  { to: '/donate', label: 'Donate' },
];
function App() {

  return (
    <div className={`app-shell dojo-theme `}>
      <header className={`site-header varsity-header`}>

        <div className="header-bar">
          <div className="varsity-logo-block">
            <a href="https://dojoofpain.com/">
              <img src="./dojo.png" className="brand-mark" alt="Dojo monogram" />
            </a>
          </div>
          <nav className="main-nav">
            {navLinks.map(({ to, label }) => (
              <NavLink
                key={label}
                to={to}
                end={to === '/'}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/training-philosophy" element={<TrainingPhilosophy />} />
          <Route path="/routes" element={<RoutesPage />} />
          <Route path="/run-with-us" element={<RunWithUs />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </main>
      <Footer />
      <Analytics />

    </div>
  );
}

export default App;
